import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import {
  GetUserSigninHistoryQuery,
  GetUserSigninHistoryQueryVariables,
} from '@investigator/shared/generated/graphql';

export const GET_ENTRA_SIGNIN_HISTORY_QUERY = gql`
  query GetUserSigninHistory(
    $input: EntraSigninHistorySearchInput!
    $provider_name: EDRConfigurationType!
  ) {
    getUserSigninHistory(input: $input, provider_name: $provider_name) {
      offset
      size
      total_items
      items {
        signin {
          tenant
          timestamp
          microsoft_entra_id {
            user_id
            user_principal_name
            sign_in {
              event_id
              created_date_time
              created_date_time_epoch
              external_ip
              application_display_name
              client_app_used
              conditional_access_status
              risk_level_aggregated
              risk_level_during_signin
              status {
                errorCode
                failureReason
                additionalDetails
              }
              location {
                city
                state
                country_or_region
              }
              device_detail {
                device_id
                display_name
                operating_system
                is_compliant
                is_managed
              }
            }
            metadata {
              last_refreshed_at
              source
            }
            raw
          }
        }
        user {
          tenant
          timestamp
          microsoft_entra_id {
            id
            user_principal_name
            display_name
            given_name
            surname
            mail
            job_title
            department
            office_location
            business_phones
            mobile_phone
            account_enabled
            risk_level
            ADGroup
            raw
          }
        }
      }
    }
  }
`;

export const useGetEntraSigninHistory = (
  options?: QueryHookOptions<
    GetUserSigninHistoryQuery,
    GetUserSigninHistoryQueryVariables
  >,
) => {
  return useQuery<
    GetUserSigninHistoryQuery,
    GetUserSigninHistoryQueryVariables
  >(GET_ENTRA_SIGNIN_HISTORY_QUERY, options);
};
